import { TmsContextType } from '@awaze/mfe-common.contexts.tms'
import {
  DataLayerEventType,
  DataLayerFactory,
} from '@awaze/mfe-common.contexts.tms'
import { dataLayerErrorHandler } from 'src/utils/dataLayerErrorHandler'

interface FireFacetClearAllEventProps {
  tms: TmsContextType
}

export const fireFacetClearAllEvent = ({
  tms,
}: FireFacetClearAllEventProps): void => {
  new DataLayerFactory()
    .getEvent(DataLayerEventType.FacetClearAll)
    .update(tms, {}, dataLayerErrorHandler)
}
